// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1V7I9","right":"Footer_right__2pqH_","buttons":"Footer_buttons__VK9hE"};